import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import DefaultAvatar from "../Assets/defaultAvatar.png";
import EditSvg from "../Assets/Icons/editIcon.svg";

export default function IndivisualProfile() {
  return (
    <DashboardLayout>
      <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs links={[{ name: "Individual profile", link: "dsads" }]} />
        <h1 className="text-xl font-semibold">Individual Profile</h1>
      </section>
      <section className="bg-[#f9fafb] w-full flex items-start justify-center pt-6">
        <div className="px-8">
          <div className="flex items-start justify-between">
            <div
              style={{ boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)" }}
              className="w-full pt-8 pb-7 bg-white rounded-[8px] px-8"
            >
              <div className="flex items-center flex-col gap-6">
                <img className="w-[9rem] h-[9rem]" src={DefaultAvatar} />
                <div className="flex flex-col items-center justify-center gap-1">
                  <p className="text-[1.2rem] font-[700]">Thomas Lean</p>
                  <p className="text-[1rem] text-[#6B7280]">Data Scientist</p>
                </div>
                <div>
                  <button className="w-[20.3rem] h-[2.5rem] rounded-[8px] bg-[#942A27] text-[0.90rem] text-white font-[500] flex items-center justify-center gap-2">
                    <img src={EditSvg} /> Edit Profile
                  </button>
                </div>
              </div>
            </div>
            <div className="ml-6" >
            <div
              style={{
                boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              }}
              className="w-[100%] pt-10 pb-10 bg-white rounded-[8px] px-6"
            >
              <h1 className="text-[1.1rem] font-[700]">General information</h1>
              <div>
                  <div className="flex items-center justify-between mt-4 gap-3">
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        First Name
                      </label>
                      <input
                        className="w-[18.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="Thomas"
                      />
                    </div>
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Last Name
                      </label>
                      <input
                        className="w-[18.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="Lean"
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-4 gap-3">
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Organization
                      </label>
                      <input
                        className="w-[18.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="Organization Name"
                      />
                    </div>
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Role
                      </label>
                      <select className="p-2.5 w-[18.6rem] h-[2.6rem]  bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] border rounded-md shadow-sm outline-none appearance-none">
                          <option>Data Scientist</option>
                          <option>Full Stack Developer</option>
                          <option>Machine Learning Engineer</option>
                          <option>Data Engineer</option>
                          <option>Decision Scientist</option>
                          <option>Front End Developer</option>
                          <option>Back End Developer</option>
                          <option>AI Translator</option>
                          <option>Business Stakeholder</option>
                          <option>Domain Expert</option>
                          <option>Product Manager</option>
                          <option>Project Manager</option>
                          <option>AI Architect</option>
                          <option>Manager</option>
                          <option>Leadership</option>
                          <option>Executive Sponsor</option>
                          <option>DevOps Expert</option>
                          <option>Database Administrator</option>
                          <option>AI Specialist/Research Scientist</option>
                          <option>Data Analyst</option>
                          <option>Business Intelligence Analyst</option>
                          <option>Data Visualization Expert</option>
                          <option>Statistician</option>
                          <option>Data Governance</option>
                          <option>Quality Officer</option>
                          <option>UI/UX Designer</option>
                          <option>Other</option>
                        </select>
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-4 gap-3">
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Email
                      </label>
                      <input
                        className="w-[18.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="email@email.com"
                      />
                    </div>
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Team Name
                      </label>
                      <select className="p-2.5 w-[18.6rem] h-[2.6rem]  bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] border rounded-md shadow-sm outline-none appearance-none">
                          <option>Team 1</option>
                          <option>Team 2</option>
                          <option>Team 3</option>
                          <option>Team 4</option>
                        </select>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-start flex-col gap-1 mt-3">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        City
                      </label>
                      <input
                        className="w-[18.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="San Francisco"
                      />
                    </div>
                  </div>
                  <div className="flex items-start flex-col gap-1 mt-4">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      Bio
                    </label>
                    <textarea
                      className="w-full h-[6.9rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-3"
                      placeholder="Please share a brief biography that encapsulates your journey, highlighting your major accomplishments and areas of expertise in Artificial Intelligence. This bio will help others understand your unique perspective and contributions to the field."
                    ></textarea>
                  </div>
                  <div className="mt-6">
                    <button className="w-[5.75rem] h-[2.5rem] rounded-[8px] bg-[#942A27] text-white">
                      Save all
                    </button>
                  </div>
              </div>
              <div className="flex item-center flex-col gap-4 mt-6">
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                          University
                        </p>
                        <p className="text-[1rem] font-[600] text-[#111928]">
                          Lorem University
                        </p>
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                          Degree Level
                        </p>
                        <select className="p-2.5 text-[1rem] font-[600] text-[#111928] bg-white border rounded-md shadow-sm outline-none appearance-none">
                          <option>Bachelor's Degree</option>
                          <option>Associate's degree</option>
                          <option>Postgraduate Certificate / Diploma</option>
                          <option>Master's degree</option>
                          <option>Professional degree</option>
                          <option>Doctorate degree (Ph.D.)</option>
                          <option>Post-doctorate</option>
                          <option>Unspecified</option>
                        </select>
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                          Program
                        </p>
                        <input
                          className="w-[220px] h-[2.6rem] border-[1px] border-[#D1D5DB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                          type="text"
                          placeholder="Enter Degree Program"
                        />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                          Experience Level
                        </p>
                        <select className="p-2.5 text-[1rem] font-[600] text-[#111928] bg-white border rounded-md shadow-sm outline-none appearance-none">
                          <option>Entry-level (0-2 years)</option>
                          <option>Junior level (2-5 years)</option>
                          <option>Mid-level (5-10 years)</option>
                          <option>Senior level (Over 10 years)</option>
                          <option>Management</option>
                          <option>Director</option>
                          <option>Executive</option>
                        </select>
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                          Organization
                        </p>
                        <p className="text-[1rem] font-[600] text-[#111928]">
                        Organization Name
                        </p>
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                          Team name
                        </p>
                        <input
                          className="w-[220px] h-[2.6rem] border-[1px] border-[#D1D5DB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                          type="text"
                          placeholder="Insert Team Name"
                        />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                        What types of AI projects are you seeking?
                        </p>
                        <input
                          className="w-[220px] h-[2.6rem] border-[1px] border-[#D1D5DB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                          type="text"
                          placeholder="Add text"
                        />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                        What sectors are you interested in?
                        </p>
                        <input
                          className="w-[220px] h-[2.6rem] border-[1px] border-[#D1D5DB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                          type="text"
                          placeholder="Add text"
                        />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-[1rem] text-[#6B7280] font-[500]">
                        What are your research interests?
                        </p>
                        <input
                          className="w-[220px] h-[2.6rem] border-[1px] border-[#D1D5DB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                          type="text"
                          placeholder="Add text"
                        />
                      </div>
                    </div>
            </div>
            {/* <div>
              <div
                style={{
                  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                }}
                className="w-full pt-4 pb-4 bg-white rounded-[8px] gap-4 px-6 mt-6"
              >
                <h1 className="text-[1.1rem]">Password information</h1>
                <div className="flex items-center gap-4 mt-6">
                  <div className="flex items-start flex-col gap-1">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      Current password
                    </label>
                    <input
                      className="w-[12.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="text"
                      placeholder="••••••••••"
                    />
                  </div>
                  <div className="flex items-start flex-col gap-1">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      Confirm new password
                    </label>
                    <input
                      className="w-[12.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="text"
                      placeholder="••••••••••"
                    />
                  </div>
                  <div className="flex items-start flex-col gap-1">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                    New password
                    </label>
                    <input
                      className="w-[12.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="text"
                      placeholder="••••••••••"
                    />
                  </div>
                </div>
                <div className="mt-6">
                    <button className="w-[5.75rem] h-[2.5rem] rounded-[8px] bg-[#942A27] text-white">
                      Save all
                    </button>
                  </div>
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
}
